<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCEMENT')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCEMENT'),
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <v-card>
      <v-tabs v-model="selectedTab" @change="onTabChange">
        <v-tab :href="'#parking-fines'">
          {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINES') }}
        </v-tab>
        <v-tab v-if="isGlobalAdmin" :href="'#parking-status-check-logs'">
          {{
            $vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_STATUS_CHECK_LOGS')
          }}
        </v-tab>
        <v-tab v-if="isGlobalAdmin" :href="'#parking-fine-reports'">
          {{
            $vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.TITLE')
          }}
        </v-tab>
        <v-tab v-if="isGlobalAdmin" :href="'#enforcement-officers'">
          {{
            $vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCEMENT_OFFICERS.TITLE')
          }}
        </v-tab>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item :value="'parking-fines'">
            <parking-fines />
          </v-tab-item>
          <v-tab-item v-if="isGlobalAdmin" :value="'parking-status-check-logs'">
            <parking-status-check-logs />
          </v-tab-item>
          <v-tab-item v-if="isGlobalAdmin" :value="'parking-fine-reports'">
            <parking-fine-reports-tab />
          </v-tab-item>
          <v-tab-item v-if="isGlobalAdmin" :value="'enforcement-officers'">
            <enforcement-officers-tab />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    ParkingFines: () =>
      import(
        /* webpackChunkName: "ParkingFines" */ '@/components/enforcement/ParkingFines.vue'
      ),
    ParkingStatusCheckLogs: () =>
      import(
        /* webpackChunkName: "ParkingStatusCheckLogs" */ '@/components/enforcement/ParkingStatusCheckLogs.vue'
      ),
    ParkingFineReportsTab: () =>
      import(
        /* webpackChunkName: "ParkingFineReportsTab" */ '@/components/enforcement/ParkingFineReportsTab.vue'
      ),
    EnforcementOfficersTab: () =>
      import(
        /* webpackChunkName: "EnforcementOfficersTab" */ '@/components/enforcement/EnforcementOfficersTab.vue'
      )
  },
  data() {
    return {
      selectedTab: 'parking-fines'
    }
  },
  computed: {
    ...mapGetters('authentication', ['isGlobalAdmin'])
  },
  watch: {
    // Watch for changes in the route and update the selected tab accordingly
    '$route.query.tab': function(newTab) {
      if (newTab && newTab !== this.selectedTab) {
        this.selectedTab = newTab
      }
    }
  },
  mounted() {
    const initialTab = this.$route.query.tab || 'parking-fines'
    this.selectedTab = initialTab
    if (this.$route.query.tab !== initialTab) {
      this.$router.replace({ query: { ...this.$route.query, tab: initialTab } })
    }
  },
  methods: {
    onTabChange(newTab) {
      if (this.$route.query.tab !== newTab) {
        this.$router.push({
          query: { ...this.$route.query, tab: newTab }
        })
      }
    }
  }
}
</script>
